export const COUNTRY_ISO_CODE = {
  BRAZIL: 'BR',
  MEXICO: 'MX',
  COLOMBIA: 'CO'
} as const;

export const ISO_TO_APP_LOCALE = {
  [COUNTRY_ISO_CODE.BRAZIL]: 'pt-BR',
  [COUNTRY_ISO_CODE.MEXICO]: 'es-MX',
  [COUNTRY_ISO_CODE.COLOMBIA]: 'es-CO'
} as const;

export type Iso2WithAppLocale = keyof typeof ISO_TO_APP_LOCALE;

/**
 * Aceita apenas ISO 3166-1 alpha-2 (`BR`, `MX`), case-insensitive.
 */
export function normalizeCountryToIso2(
  country: string
): Iso2WithAppLocale | null {
  const u = country.trim().toUpperCase();
  return isIso2WithAppLocale(u) ? u : null;
}

export type AppLocaleCode = (typeof ISO_TO_APP_LOCALE)[Iso2WithAppLocale];

function isIso2WithAppLocale(iso2: string): iso2 is Iso2WithAppLocale {
  return Object.hasOwn(ISO_TO_APP_LOCALE, iso2);
}

export function appLocaleFromIso2(
  iso2: string | undefined | null
): AppLocaleCode | undefined {
  if (iso2 === null || !isIso2WithAppLocale(iso2)) {
    return undefined;
  }

  return ISO_TO_APP_LOCALE[iso2];
}
